module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Dislike.28956c88.svg";